import PropTypes from 'prop-types'
import API from '../../../utils/http/api'

export const REQUEST = 'steppingblocks/payment/REQUEST'
export const SUCCESS = 'steppingblocks/payment/SUCCESS'
export const FAILURE = 'steppingblocks/payment/FAILURE'

// Start reducer
const initialState = {
  error: null,
  requestEnded: false,
  requestStarted: false,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
      }
    case FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
      }
    default:
      return _state
  }
}

// Start actions
export const performSteppingblocksPayment = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    await API.post('/users/register_for_paid_plan', params)
    dispatch({ type: SUCCESS })
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message }})
    throw new Error(error.message)
  }
}

export const performUpdatePaymentMethod = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { user } = await API.post('/payments/stripe/update_payment', params)
    dispatch({ type: SUCCESS })
    return user
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw new Error(error.message)
  }
}

export const performRecreateSubscription = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { user } = await API.post('/payments/stripe/subscription', params)
    dispatch({ type: SUCCESS })
    return user
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw new Error(error.message)
  }
}

// State PropTypes
export const paymentPropTypes = PropTypes.shape({
  error: PropTypes.any,
  requestEnded: PropTypes.bool.isRequired,
  requestStarted: PropTypes.bool.isRequired,
})

// Start test data
export const paymentTestData = {
  error: null,
  requestEnded: false,
  requestStarted: false,
}



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Onboarding/paymentDuck.js